import { el, setAttr } from 'redom';

import { stringToSVG } from 'utilities';

import AddIconString from 'assets/images/add-icon.svg?raw';

const AddIcon = stringToSVG(AddIconString);

class AddNewItemButton {

  constructor(configuration) {

    this.onClick = configuration.onClick;

    this.label = el('span', configuration.label);

    this.el = el('button.add-new-item-button', {
      type: 'button',
      class: 'second-level-cta left-control',
      onclick: this.handleClick.bind(this)
    }, [
      AddIcon.cloneNode(true),
      this.label
    ]);

  }

  handleClick(event) {
    return this.onClick(event);
  }

  show() {

    setAttr(this.el, {
      style: {
        display: 'flex'
      }
    });

  }

  hide() {

    setAttr(this.el, {
      style: {
        display: 'none'
      }
    });

  }

  scrollIntoView() {

    this.el.scrollIntoView({
      block: 'start',
      inline: 'nearest',
      behavior: 'smooth'
    });

  }

  update(configuration) {

    this.label.textContext = configuration.label;
    this.onClick = configuration.onClick;

  }

}

export default AddNewItemButton;